<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,12C1.9,12,1,12.9,1,14C1,15.1,1.9,16,3,16C4.1,16,5,15.1,5,14C5,12.9,4.1,12,3,12C3,12,3,12,3,12ZM2.5,5.5C1.12,5.5,0,6.62,0,8C0,9.38,1.12,10.5,2.5,10.5C3.88,10.5,5,9.38,5,8C5,6.62,3.88,5.5,2.5,5.5C2.5,5.5,2.5,5.5,2.5,5.5ZM7,3C7,3,15,3,15,3C15.55,3,16,2.55,16,2C16,1.45,15.55,1,15,1C15,1,7,1,7,1C6.45,1,6,1.45,6,2C6,2.55,6.45,3,7,3C7,3,7,3,7,3ZM15,13C15,13,7,13,7,13C6.45,13,6,13.45,6,14C6,14.55,6.45,15,7,15C7,15,15,15,15,15C15.55,15,16,14.55,16,14C16,13.45,15.55,13,15,13C15,13,15,13,15,13ZM3,0C1.9,0,1,0.9,1,2C1,3.1,1.9,4,3,4C4.1,4,5,3.1,5,2C5,0.9,4.1,0,3,0C3,0,3,0,3,0ZM15,6C15,6,7,6,7,6C6.45,6,6,6.45,6,7C6,7,6,9,6,9C6,9.55,6.45,10,7,10C7,10,15,10,15,10C15.55,10,16,9.55,16,9C16,9,16,7,16,7C16,6.45,15.55,6,15,6C15,6,15,6,15,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Property',
} as DefineComponent
</script>
